import { httpClient, Service } from "./client";

class ProductOfferingService extends Service {
  getProductOfferings(hotelChainId: string) {
    return httpClient.get(
      `/productofferings/${hotelChainId}`,
      this.authHeader()
    );
  }
  getProductOfferingById(hotelChainId: string, productOfferingId: string) {
    return httpClient.get(
      `/productofferings/${hotelChainId}/${productOfferingId}`,
      this.authHeader()
    );
  }
}

export const productOfferingService = new ProductOfferingService();
